import { render, staticRenderFns } from "./OutfitsIndex.vue?vue&type=template&id=04fa9fd4&scoped=true"
import script from "./OutfitsIndex.vue?vue&type=script&lang=js"
export * from "./OutfitsIndex.vue?vue&type=script&lang=js"
import style0 from "./OutfitsIndex.vue?vue&type=style&index=0&id=04fa9fd4&prod&lang=scss&scoped=true"
import style1 from "./OutfitsIndex.vue?vue&type=style&index=1&id=04fa9fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa9fd4",
  null
  
)

export default component.exports